<template>
  <div v-loading="$wait.waiting(_uid)" class="card training-schedule">
    <div class="card-content">
      <div class="row mt-s">
        <ScheduleTable :data="schedule" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ScheduleTable from "@/components/Dashboard/Views/Pages/Training/Components/ScheduleTable";

export default {
  components: {
    ScheduleTable,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("companyUserStore", ["user", "schedule"]),
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      await this.getUsersSchedule(this.user.id);
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("companyUserStore", ["getUsersSchedule"]),
    ...mapActions("errorStore", ["addNewError"]),
  },
};
</script>

<style lang="scss"></style>
